import { t } from 'i18next';
import { cssTransition, toast } from 'react-toastify';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { Error } from '@mui/icons-material';

export const fadeAnimation = cssTransition({
    enter: 'animate__animated animate__fadeIn',
    exit: 'animate__animated animate__fadeOut',
});

export const copyMessage = () => {
    toast.success(t('messages.copy_message'), {
        position: 'bottom-right',
        icon: <TaskAltOutlinedIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });
};

export const feedbackMessage = () => {
    toast.success(t('web_app.messages.feedback_sent'), {
        position: 'bottom-right',
        icon: <TaskAltOutlinedIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });
};

export const jobPermissionError = () =>
    toast.error(t('web_app.messages.job_permission_error'), {
        position: 'top-center',
        icon: <ErrorOutlineIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });

export const userAccessErrorMessage = () =>
    toast.error(t('web_app.auth.block_error'), {
        position: 'top-center',
        icon: <ErrorOutlineIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });

export const notJobMessage = () =>
    toast.error(t('web_app.messages.not_job'), {
        position: 'top-center',
        icon: <ErrorOutlineIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });

export const biasCheckFail = () =>
    toast.error(t('web_app.messages.bias_check_failed'), {
        position: 'top-center',
        icon: <ErrorOutlineIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });

export const saveDraftSuccess = (isDraft?: boolean) =>
    isDraft
        ? toast.success(t('web_app.messages.save_draft'), {
              position: 'bottom-right',
              icon: <TaskAltOutlinedIcon />,
              hideProgressBar: true,
              transition: fadeAnimation,
          })
        : saveMessage();

export const saveMessage = () =>
    toast.success(t('web_app.messages.save'), {
        position: 'bottom-right',
        icon: <TaskAltOutlinedIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });

export const popupErrorMessage = (link: string) =>
    toast.info(
        <div className="toast-container">
            <div>{t('web_app.messages.pop_up_warn')}</div>
            <div>
                <a href={link} target="_blank" rel="noreferrer">
                    {t('web_app.messages.pop_up_warn_click_here')}
                </a>
            </div>
        </div>,
        {
            autoClose: false,
            position: 'top-center',
            icon: <InfoOutlinedIcon />,
            className: 'custom-info-toast',
            transition: fadeAnimation,
        },
    );

export const undoDeletedDraftMessage = (callback: () => void) =>
    toast.success(
        <div className="toast-container">
            <div>{t('web_app.messages.undo_delete')}</div>
            <div className="undo-message">
                <button onClick={callback}>{t('web_app.undo_btn')}</button>
            </div>
        </div>,
        {
            autoClose: 60000,
            className: 'custom-delete-toast',
            position: 'top-center',
            icon: <TaskAltOutlinedIcon />,
            transition: fadeAnimation,
        },
    );

export const saveFiltersMessage = () =>
    toast.success('Successfully Saved', {
        position: 'bottom-right',
        icon: <TaskAltOutlinedIcon />,
        hideProgressBar: true,
        transition: fadeAnimation,
    });
